import { getDefaultConfig } from "@rainbow-me/rainbowkit";
import { defineChain } from "viem";

export const robinhoodChain = defineChain({
  id: Number(import.meta.env.VITE_CHAIN_ID ?? 4663),
  name: "Robinhood Chain",
  nativeCurrency: {
    name: "ETH",
    symbol: "ETH",
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: [import.meta.env.VITE_RPC_URL as string],
    },
  },
  blockExplorers: {
    default: {
      name: "Robinhood Explorer",
      url: (import.meta.env.VITE_ROBINHOOD_EXPLORER_URL as string) ?? "",
    },
  },
});

export const wagmiConfig = getDefaultConfig({
  appName: "Cat Claw",
  projectId:
    (import.meta.env.VITE_WALLETCONNECT_PROJECT_ID as string) ??
    "YOUR_WALLETCONNECT_PROJECT_ID",
  chains: [robinhoodChain],
  ssr: false,
});
